// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  pleasureX10: __t.i32().name("pleasure_x_10"),
  arousalX10: __t.i32().name("arousal_x_10"),
  dominanceX10: __t.i32().name("dominance_x_10"),
  basePleasureX10: __t.i32().name("base_pleasure_x_10"),
  baseArousalX10: __t.i32().name("base_arousal_x_10"),
  baseDominanceX10: __t.i32().name("base_dominance_x_10"),
  updatedAt: __t.timestamp().name("updated_at"),
});
